import { render } from "./TemplateModalParkingZone.vue?vue&type=template&id=4b58a79a&scoped=true&ts=true"
import script from "./TemplateModalParkingZone.vue?vue&type=script&lang=ts"
export * from "./TemplateModalParkingZone.vue?vue&type=script&lang=ts"

import "./TemplateModalParkingZone.vue?vue&type=style&index=0&id=4b58a79a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b58a79a"]])

export default __exports__